import '@/utils/escapeLayerStack'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './style.css'

// Configurar Pinia
const pinia = createPinia()

// Configurar Toast
const toastOptions = {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
}

// Criar aplicação
const app = createApp(App)

app.use(pinia)
app.use(i18n)
app.use(router)
app.use(Toast, toastOptions)

app.mount('#app')
console.log('✅ Aplicação montada com sucesso!')
